// extracted by mini-css-extract-plugin
export default {"synchronized-inboxes__table":"SynchronizedInboxes_synchronized-inboxes__table__kG+TQ","synchronized-inboxes__error":"SynchronizedInboxes_synchronized-inboxes__error__XK8Ma"};